export default __webpack_public_path__ + "static/media/0077.07dc8e88.jpg";